import React from 'react';
import styled from 'styled-components';

import img0 from '../../assets/screens/screen-add-passengers.png';
import img1 from '../../assets/screens/screen-add-passengers-max.png';
import img2 from '../../assets/screens/screen-add-passengers-minus-plus.png';
import img3 from '../../assets/screens/screen-confirmation-multiple-value.png';
import img4 from '../../assets/screens/screen-confirmation-multiple.png';
import img5 from '../../assets/screens/screen-confirmation-seasonal-ticket.png';
import img6 from '../../assets/screens/screen-confirmation-single-ticket.png';
import img7 from '../../assets/screens/screen-show-card.png';
import img8 from '../../assets/screens/zone-a.png';
import img9 from '../../assets/screens/zone-b-1.png';
import img10 from '../../assets/screens/zone-c-1.png';
import img11 from '../../assets/screens/zone-d-1.png';
import img12 from '../../assets/screens/zone-b-2.png';
import img13 from '../../assets/screens/zone-c-2.png';
import img14 from '../../assets/screens/zone-d-2.png';
import img15 from '../../assets/images/btn-add-passengers-small.png';
import img16 from '../../assets/images/btn-minus-active.png';

const images = [
  img0,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
];

const Image = styled.img`
  position: absolute;
  bottom: -10px;
  opacity: 0.001;
  width: 10px;
  height: 10px;
`;

const ImagePreloader = () =>
  images.map((source) => <Image key={source} src={source} />);

export default ImagePreloader;
